import { setLoadingStateForFolderTreeMutator } from '../mutators/setLoadingStateForFolderTreeMutator';
import type FolderTreeLoadStateEnum from '../store/schema/FolderTreeLoadStateEnum';
import type { MailboxInfo } from 'owa-client-types';

export async function setLoadingStateForFolderTree(
    folderTreeId: string,
    loadingState: FolderTreeLoadStateEnum,
    mailboxInfo: MailboxInfo
): Promise<void> {
    setLoadingStateForFolderTreeMutator(folderTreeId, loadingState, mailboxInfo);
}
